const GET_DRIVE_TRAIN = 'GET_DRIVE_TRAIN';
const SET_DRIVE_TRAIN = 'SET_DRIVE_TRAIN';

export {
    GET_DRIVE_TRAIN,
    SET_DRIVE_TRAIN
};
